var _path, _rect, _rect2, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTicket2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 125,
    height: 94,
    viewBox: "0 0 125 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.29935 36.8801L94.6296 3.371C96.5309 7.81703 101.631 9.98618 106.173 8.22303C106.27 8.18539 106.366 8.14626 106.461 8.10568L110.512 18.5434C110.415 18.5775 110.318 18.6133 110.221 18.651C105.581 20.4518 103.28 25.6725 105.081 30.3119C106.882 34.9512 112.103 37.2524 116.742 35.4516C116.839 35.414 116.935 35.3748 117.03 35.3343L120.856 45.1927C120.759 45.2268 120.662 45.2626 120.565 45.3003C115.925 47.101 113.624 52.3218 115.425 56.9612C115.463 57.0581 115.502 57.154 115.542 57.2489L29.2121 90.758C29.178 90.6606 29.1422 90.5634 29.1045 90.4665C27.3414 85.9241 22.2997 83.6232 17.7352 85.2192L13.9087 75.3608C18.3546 73.4594 20.5237 68.3596 18.7606 63.8172C16.9975 59.2748 11.9558 56.9739 7.3913 58.5699L3.33987 48.1322C7.69098 46.2714 9.86136 41.3472 8.29935 36.8801Z",
    fill: "#006EB8"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 18.5683,
    y: 37.5605,
    width: 74.5731,
    height: 49.094,
    transform: "rotate(-21.2137 18.5683 37.5605)",
    fill: "#006EB8"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 19.8624,
    y: 38.1309,
    width: 72.5731,
    height: 47.094,
    transform: "rotate(-21.2137 19.8624 38.1309)",
    stroke: "black",
    strokeOpacity: 0.4,
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9724 47.1921L82.4776 28.753",
    stroke: "black",
    strokeOpacity: 0.4,
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5704 56.4614L86.0756 38.0223",
    stroke: "black",
    strokeOpacity: 0.4,
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicket2);
export default __webpack_public_path__ + "static/media/ticket2.9d0e9c966706e92bf84ebcc76f5fa868.svg";
export { ForwardRef as ReactComponent };